import { user, listen, isAdmin } from '../services/auth.service'
import { create, upload } from '../services/fire.service';
const imageGallery = 'https://firebasestorage.googleapis.com/v0/b/sons-of-the-forest.appspot.com/o/assets%2Fimage-gallery.svg?alt=media&token=3295c81d-a2a7-4625-96fd-839e65c2a7af'

export class PinDialog extends HTMLElement {
  status = 'pending'
  category = ''

  constructor() {
    super();
    listen(() => this.checkStatus())
  }

  close(aux = null) {
    if (aux) {
      const evt = new CustomEvent("onclose", {
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: {
          ...aux,
          'marker-url': aux.pin,
        }
      });
      this.dispatchEvent(evt);
    }
    return this.parentNode.removeChild(this)
  }

  async submit() {
    const form = this.querySelector('form')
    const data = Object.fromEntries(new FormData(form).entries());

    const rand = () => Math.random().toString(36).substr(8)
    const promises = [new Promise(r => r(1))].splice(0, 0)

    let pin = ''
    let image = ''

    if (data.pin instanceof File) {
      promises.push(
        upload(`/pins/${Date.now()}_${rand()}_${data.pin.name}`, data.pin)
        .then(res => {
          pin = res
        })
      )
    } else {
      pin = data.pin
    }
    if (data.image instanceof File) {
      promises.push(
        upload(`/pins/${Date.now()}_${rand()}_${data.image.name}`, data.image)
        .then(res => {
          image = res
        })
      )
    } else {
      image = data.image
    }

    await Promise.all(promises)

    console.log('WRITE', {
      id: this.getAttribute('id'),
      ...data,
      pin,
      image
    })
    const aux = {
      ...data,
      status: this.status,
      user_id: user.value.uid,
      email: user.value.email,
      size: Number(data.size),
      lng: Number(data.lng),
      lat: Number(data.lat),
      pin,
      image
    }

    if (this.id) {
      return create(`items/${this.id}`, aux)
      .then(() => this.close(aux))
    } else {
      return create('items', aux)
      .then(() => this.close(aux))
    }
  }

  checkStatus() {
    isAdmin().then(admin => {
      if (admin) {
        this.status = 'published'
      } else {
        this.status = 'pending'
      }
      this.querySelector('[name=status]').value = this.status
    })

    this.id = this.getAttribute('id') || ''
    this.category = this.getAttribute('category')
    this.item = this.getAttribute('item') || ''
    this.name = this.getAttribute('name') || ''
    this.lng = this.getAttribute('lng')
    this.lat = this.getAttribute('lat')
    this.size = this.getAttribute('size')
    this.pin = this.getAttribute('pin')
    this.description = this.getAttribute('description')
    this.image = this.getAttribute('image')
    this.link = this.getAttribute('link') || ''
    this.mode = this.getAttribute('mode') || 'create'
  }

  onChange() {
    const values = [...this.querySelectorAll('[required]')].map(node => node.value)
    const ok = Boolean(values.find(i => !i) ?? true)

    if (ok) {
      this.querySelector('button[type=submit]').removeAttribute('disabled')
      this.querySelector('.error').innerHTML = ''
    } else {
      this.querySelector('button[type=submit]').setAttribute('disabled', '')
    }
  }

  openSelector() {
    const dialog = document.createElement('image-selector')
    dialog.setAttribute('images', this.getAttribute('images'))
    document.body.appendChild(dialog)
    dialog.addEventListener('onSelection', ev => {
      console.log(ev)
      const field = this.querySelector('#pin-file')
      field.type = 'text'
      field.value = ev.detail
    })
  }

  handleEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.srcElement.classList.contains('e:close')) {
      return this.close()
    }
    if (event.srcElement.classList.contains('e:submit')) {
      event.srcElement.setAttribute('disabled', '')
      return this.submit()
    }
    if (event.srcElement.classList.contains('e:selector')) {
      return this.openSelector()
    }
    if (event.type === 'input') {
      this.onChange()
    }
  }

  connectedCallback() {
    this.checkStatus()
    this.innerHTML = `
      <style>
        #pin-dialog {
          max-width: min(420px, 80vw);
          position: absolute;
          margin-left: auto;
          margin-right: auto;
          left: 0;
          right: 0;
          text-align: center;
        }
        dialog::backdrop {
          background: repeating-linear-gradient(
            45deg,
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.4) 1px,
            rgba(0, 0, 0, 0.6) 1px,
            rgba(0, 0, 0, 0.6) 20px
          );
        }
        #pin-dialog {
          display: block;
          min-width: 280px;
          background: #232323;
          color: white;
          padding: 0;
          position: relative;
          overflow: hidden;
          border-radius: var(--border-radius-v2);
          padding: 0 15px 20px 15px;
          box-shadow: 0 0 10px #232323;
          border: 1px solid #232323;
          transform: translateZ(0);
          background: linear-gradient(180deg, #232323, #111)

        }
        #pin-dialog .close-dialog {
          font-size: 22px;
          color: white;
          text-shadow: 0 0 2px black;
        }
        #pin-dialog h2 {
          font-weight: 400;
          font-size: 24px;
          margin-bottom: 0;
        }
        #pin-dialog .btn-grad {
          border: 1px solid #232323;
        }
        #pin-dialog .large {
          font-size: 16px;
          padding: 8px 20px;
        }
        button:disabled {
          opacity: .5;
          filter: grayscale(1);
        }
        #pin-dialog label {
          display: block;
        }
        #pin-dialog .error {
          color: coral;
        }
        #pin-dialog .btn-clear {
          border: none;
          background: transparent;
          color: white;
        }
        #pin-dialog .color-orange {
          color: #fa4804;
        }
        .w50 {
          width: calc(50% - 3px);
        }
        .w80 {
          width: calc(100% - 40px);
        }
        .p6 {
          padding: 6px;
        }
        .select-img {
          cursor: pointer;
          padding: 5px 10px;
          position: relative;
          display: inline-block;
          text-align: left;
          height: 43px;
          user-select: none;
        }
        .select-img img {
          width: 20px;
          position: relative;
          top: 4px;
        }
        .block {
          display: block;
        }
      </style>
      <dialog id="pin-dialog">
        <section>
          ${this.mode === 'create' ? '<h1>✨ New Pin</h1>' : '<h1>✏️ Edit Pin</h1>'}
          <button class="mapboxgl-popup-close-button click e:close" type="button" aria-label="Close popup" aria-hidden="true">×</button>
          <form>
            <input type="hidden" required readonly value="${this.status}" name="status" placeholder="Status" class="search-input my-10 w50 onchange"/>
            <input type="hidden" required readonly value="${this.lng}"  name="lng" placeholder="Longitude" class="search-input my-10 w50 onchange"/>
            <input type="hidden" required readonly value="${this.lat}"  name="lat" placeholder="Latitude" class="search-input my-10 w50 onchange"/>
            <select name="category" required placeholder="category" class="search-input my-10 onchange">
              <option disabled selected>Category</option>
              <option ${this.category === 'Animals' && 'selected'} value="Animals">Animals</option>
              <option ${this.category === 'Important Items' && 'selected'} value="Important Items">Important Items</option>
              <option ${this.category === 'Items' && 'selected'} value="Items">Items</option>
              <option ${this.category === 'Locations' && 'selected'} value="Locations">Locations</option>
              <option ${this.category === 'Plants' && 'selected'} value="Plants">Plants</option>
            </select>
            <input id="item" required name="item" value="${this.item}" placeholder="Item" list="items" class="search-input my-10 onchange"/>
            <datalist id="items">
              ${
                [...document.querySelectorAll('#list .item')]
                .map(n => n.getAttribute('item'))
                .map(item => `<option value="${item}">${item}</option>`)
                .join('')
              }
            </datalist>
            <input id="name" required name="name" value="${this.name}" placeholder="Name" list="names" class="search-input my-10 onchange"/>
            <datalist id="names">
              ${
                [...document.querySelectorAll('#list .item')]
                .map(n => n.getAttribute('item'))
                .map(name => `<option value="${name}">${name}</option>`)
                .join('')
              }
            </datalist>
            <select name="size" required placeholder="size" class="search-input my-10 onchange">
              <option disabled selected>Size</option>
              <option ${this.size == 0.2 && 'selected'} value="0.2">xxs</option>
              <option ${this.size == 0.3 && 'selected'} value="0.3">xs</option>
              <option ${this.size == 0.4 && 'selected'} value="0.4">sm</option>
              <option ${this.size == 0.5 && 'selected'} value="0.5">md</option>
              <option ${this.size == 0.6 && 'selected'} value="0.6">lg</option>
              <option ${this.size == 0.7 && 'selected'} value="0.7">xl</option>
              <option ${this.size == 0.8 && 'selected'} value="0.8">xxl</option>
            </select>
            <span class="block">Pin image (.png)</span>
            <input id="pin-file" type="${this.id ? 'text' : 'file'}" required value="${this.pin}" name="pin" accept="image/png" class="search-input my-10 w50 onchange" onclick="this.type='file'"/>
            <span class="select-img my-10 w50 search-input click e:selector">
              <img class="e:selector" src="${imageGallery}"/>
              <span class="e:selector">Select image</span>
            </span>
            <span class="block">Popup image (.png, .jpg)</span>
            <input type="${this.id ? 'text' : 'file'}" required value="${this.image}" name="image" accept="image/png,image/jpeg" class="search-input my-10 onchange" onclick="this.type='file'"/>
            <textarea name="description" placeholder="description" class="search-input my-10 onchange">${this.description || ''}</textarea>
            <input type="url" id="link" value="${this.link}" name="link" placeholder="MMO Wiki Guide Link (https://...)" class="search-input my-10 onchange"/>

            <label class="error"></label>
            <button type="submit" disabled class="large btn-grad my-10 click e:submit">${this.mode === 'create' ? 'Create' : 'Update'}</button>
          </form>
        </section>
      </dialog>
    `
    this.querySelectorAll('.click').forEach(node => node.addEventListener("click", this))
    this.querySelectorAll('.onchange').forEach(node => node.addEventListener("input", this))

    const dialog = this.querySelector('#pin-dialog')
    if (dialog) {
      dialog.addEventListener("close", () => this.close());
      dialog.showModal()
    }
  }
}

window.customElements.define("pin-dialog", PinDialog);
